import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import i18n from "../../../../i18n";

import { leftSidebar } from "../../../../actions/sidebars";

import {
  login,
  register,
  createName,
  createAvatar,
  createTutorial,
  activateUserModal,
  modalCloseAll
} from "../../../../actions/modals";

import Logo from "../../../../assets/images/svg/logo.svg";
import LogoNick from "../../../../assets/images/logo-nick.png";
import closePopupImg from "../../../../assets/images/svg/nav-close.svg";
import MenuIcon from "../../../../assets/images/svg/nav-menu.svg";
import LeftSidebarWithoutLogin from "../../sidebars/LeftSidebar/LeftSidebarWithoutLogin";
import { logoutUserIfNeeded } from "../../../../actions/user";
import { languagesList } from "../../../../actions/profiles";
import {
  toggleHyveLogin,
  toggleHyveRegister
} from "../../../../actions/toggles";
import Select2ComponentId from "../../../../components/Select2/Select2ComponentId";
import { isNgCountry, isEnabledLanguageChange } from "../../../../utils/misc";

const RedirectLang = props => {
  const lang = i18n.language;
  const { location } = props;

  const selectLanguageOptions = [
    { id: 1, value: "en" },
    { id: 2, value: "fr" }
  ];
  let pathNames = location.pathname;
  const changeLanguageI18 = lng => {
    if (pathNames.search("/" + lang + "/") > -1) {
      pathNames = pathNames.replace("/" + lang + "/", "/" + lng + "/");
    } else {
      pathNames = pathNames.replace("/" + lang, "/" + lng);
    }
    props.history.push(pathNames);
  };
  return (
    <>
      <span className="a nav-link" style={{ width: "135px" }}>
        <Select2ComponentId
          selectOptions={selectLanguageOptions}
          onChange={event => {
            changeLanguageI18(event.text);
            localStorage.setItem("language", event.id);
          }}
          selectedValue={lang.toUpperCase()}
          labelText="lang"
        />
      </span>
    </>
  );
};
class TopNavBarWithoutLogin extends Component {
  constructor(props) {
    super(props);
    this.showLeftSidebar = this.showLeftSidebar.bind(this);
    this.hideLeftSidebar = this.hideLeftSidebar.bind(this);
  }
  showLeftSidebar() {
    this.props.leftSidebarOpen();
  }
  hideLeftSidebar() {
    this.props.leftSidebarClose();
  }

  render() {
    const { t } = this.props;
    const lang = i18n.language;
    let envClass = process.env.REACT_APP_PLATFORM === "nickx" ? " nickx" : "";
    return (
      <>
        <header>
          <nav
            className={
              "navbar navbar-expand-lg navbar-light bg-white fixed-top" +
              (this.props.isAnyModalOpen ? " isAnyModalOpen" : "")
            }
          >
            <div className="container">
              <span
                className="icon-menu d-block d-lg-none left-sidebar-collapse"
                onClick={this.showLeftSidebar}
              >
                <img src={MenuIcon} alt="" />
              </span>
              <Link to={"/" + lang} className="navbar-brand d-flex">
                <img
                  src={
                    process.env.REACT_APP_PLATFORM === "nickx" ? LogoNick : Logo
                  }
                  alt=""
                  className="mainLogo"
                />
              </Link>
              <span style={{ width: "20px" }}>
                <img
                  alt=""
                  className={
                    this.props.isAnyModalOpen ? " d-block d-lg-none" : " d-none"
                  }
                  src={closePopupImg}
                  onClick={this.props.modalCloseAll}
                />
              </span>
              <ul className="navbar-nav d-none d-lg-flex align-items-center">
                <li className="nav-item">
                  <Link
                    to={"/" + lang + "/about-us"}
                    className={"nav-link" + envClass}
                  >
                    {t("navAboutUs")}
                  </Link>
                </li>
                { 
                  !isNgCountry() ? 
                    <li className="nav-item">
                      <a
                        href={"/" + lang + "/#raffles"}
                        className={"nav-link" + envClass}
                      >
                        {t("raffles")}
                      </a>
                    </li>
                    : <></>
                }
                <li className="nav-item">
                  <a
                    href={"/" + lang + "/#tournaments"}
                    className={"nav-link" + envClass}
                  >
                    {t("navTournaments")}
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    href={"/" + lang + "/news"}
                    className={"nav-link" + envClass}
                  >
                    {t("navNews")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href={"/" + lang + "/contact-us"}
                    className={"nav-link" + envClass}
                  >
                    {t("navContactUs")}
                  </a>
                </li>
                {!this.props.isLoggedIn ? (
                  <>
                    { 
                      !isNgCountry() ?
                        <li className="nav-item">
                          <a
                            href={"/" + lang + "/billing-login"}
                            className={"nav-link" + envClass}
                          >
                            {t("signin")}
                          </a>
                        </li>
                      : 
                        <></>
                    }
                  </>
                ) : (
                    <li className="nav-item">
                      <span
                        className="a nav-link"
                        onClick={() => {
                          this.props.logoutUserIfNeeded();
                        }}
                      >
                        Sign out
                    </span>
                    </li>
                  )}
                {
                    isEnabledLanguageChange() ? 
                        <li className="nav-item">
                            <RedirectLang {...this.props} />
                        </li> 
                    : <></>
                }
                
                {/* <button
                  className="btn btn-pink light btn-xs ml-3"
                  onClick={() => {
                    this.props.resetHyveRegister();
                    this.props.registerOpen();
                  }}
                >
                  {t("joinNow")}
                </button> */}
                <a
                  href="javascript:void(0)"
                  className="btn btn-pink light btn-xs ml-3"
                  onClick={() => {
                    const that = this;
                    window.dataLayer && window.dataLayer.push({
                      'event': 'JoinHome',
                      'Click Classes': 'JoinHome',
                      'eventCallback': function () {
                        that.props.history.push("/" + lang + "/billing-info");
                      }
                    });
                    isNgCountry() && that.props.history.push("/" + lang + "/join-now");
                  }}
                >
                  {t("joinNow")}
                </a>

                {/* <button
                  className="btn btn-pink light btn-xs ml-3"
                  onClick={() => {
                    this.props.resetHyveRegister();
                    this.props.toggleHyveRegister();
                    this.props.registerOpen();
                  }}
                >
                  Join Hyve!
                </button> */}
              </ul>
            </div>
          </nav>
          <LeftSidebarWithoutLogin />
        </header>
      </>
    );
  }
}

const mapDispatchToProps = {
  leftSidebarOpen: leftSidebar.open,
  leftSidebarClose: leftSidebar.close,
  loginOpen: login.open,
  registerOpen: register.open,
  createNameOpen: createName.open,
  createAvatarOpen: createAvatar.open,
  createTutorialOpen: createTutorial.open,
  logoutUserIfNeeded,
  modalCloseAll: modalCloseAll,
  toggleHyveLogin: toggleHyveLogin.toggle,
  resetHyveLogin: toggleHyveLogin.reset,
  toggleHyveRegister: toggleHyveRegister.toggle,
  resetHyveRegister: toggleHyveRegister.reset,
  activateUserModalOpen: activateUserModal.open,
  activateUserModalClose: activateUserModal.close,
  fetchLanguagesIfNeeded: languagesList.fetchIfNeeded,
  invalidateLanguagesIfNeeded: languagesList.invalidate
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.login.isLoggedIn,
    isAnyModalOpen: state.modals.isAnyModalOpen,
    currentLang: state.login.currentLang,
    languageslist: state.profiles.languagesList.items
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(TopNavBarWithoutLogin))
);
